import React from 'react'
import AnsUser from '../ansuser/AnsUser'
import ManuOperation from './navOperationRoom/ManuOperation'

function CommentLaboratory() {
    return (
        <div className='global-page'>
            <ManuOperation menuActive={'ans'}/>
            <AnsUser roleUser={'Laboratory'} />
        </div>
    )
}

export default CommentLaboratory